import moment from "moment";

const dateTimePayload = (date: string) => {
  if (!date) return "";
  return moment(date).format("YYYY-MM-DD HH:mm:ss");
};
export default dateTimePayload;
